import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function AuthLayout() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex w-full">
      {/* Left Side - Branding (Dark) */}
      <div className="hidden lg:flex w-1/2 bg-sidebar items-center justify-center relative overflow-hidden">
        <div className="absolute inset-0 bg-primary/10" />
        <div className="relative z-10 text-center text-white p-12">
          <div className="mb-8 flex justify-center">
            <div className="h-20 w-20 bg-primary rounded-2xl flex items-center justify-center text-4xl font-bold shadow-2xl shadow-primary/50">
              T
            </div>
          </div>
          <h1 className="text-4xl font-bold mb-4">Tanazom Dashboard</h1>
          <p className="text-sidebar-foreground/60 text-lg max-w-md mx-auto">
            {t('auth.login.brandingDescription')}
          </p>
        </div>

        {/* Decorative Circles */}
        <div className="absolute -bottom-24 -start-24 w-96 h-96 bg-primary/20 rounded-full blur-3xl" />
        <div className="absolute -top-24 -end-24 w-96 h-96 bg-info/20 rounded-full blur-3xl" />
      </div>

      {/* Right Side - Form */}
      <div className="w-full lg:w-1/2 flex items-center justify-center p-8 bg-background">
        <div className="w-full max-w-md">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
